import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MeetingDoctorPage } from './meeting-doctor.page';

const routes: Routes = [
  {
    path: '',
    component: MeetingDoctorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeetingDoctorPageRoutingModule {}
